import React, { useRef, useEffect } from "react";
import styles from "./index.module.scss";
import MemberFeatures from "../MemberFeatures";
import OdometerCounter from "./OdometerCounter";

export type ClickType = "points" | "totalSaved";

interface MemberInfoCardProps {
  username?: string;
  points?: number;
  totalSaved?: number;
  isLogin?: boolean;
  onClick?: (
    type: ClickType,
    data: { points?: number; coupons?: number }
  ) => void;
}

const MemberInfoCard: React.FC<MemberInfoCardProps> = ({
  username,
  points = 0,
  totalSaved = 0,
  onClick,
}) => {
  const prevPointsRef = useRef(points);
  const prevTotalSavedRef = useRef(totalSaved);

  useEffect(() => {
    prevPointsRef.current = points;
  }, [points]);

  useEffect(() => {
    prevTotalSavedRef.current = totalSaved;
  }, [totalSaved]);

  // const handleTotalSavedClick = useCallback(() => {
  //   // sendMessageToParent({ type: "scroll-to", id: "my-coupons" });
  // }, []);

  // // 修正一下展示的图片
  // const [usePcBg, setUsePcBg] = useState(false);
  // useEffect(() => {
  //   const handleResize = () => {
  //     // 获取顶层窗口的宽度
  //     const topWindowWidth = window.top?.innerWidth;
  //     const isMobile = (topWindowWidth || 0) < 768;
  //     setUsePcBg(!isMobile);
  //   };
  //   window.addEventListener("resize", handleResize);
  // }, []);

  return (
    <div className={styles.memberInfoCard}>
      <div className={styles.infoCardBg}>
        <div className={styles.infoCardContent}>
          <div className={styles.header}>
            <div className={styles.greeting}>Hi, {username}</div>
            <div className={styles.bookmarkIcon}>
              <div className={styles.icon}></div>
            </div>
          </div>

          <MemberFeatures />
        </div>

        <img
          className={styles.memberBg_m}
          src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/member_bg_m-6.9.png?v=1749457709"
          alt="member-bg"
        />

        <img
          className={styles.memberBg_pc}
          src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/member_bg_pc-6.9.png?v=1749457709"
          alt="member-bg"
        />
      </div>

      <div className={styles.statsContainer}>
        <div
          className={styles.statItem}
          onClick={() => onClick?.("points", { points })}
        >
          <div className={styles.statValue} data-element-id="my-points">
            <OdometerCounter value={points} format="(ddd)" theme="default" />
          </div>
          <div className={styles.statLabel} data-element-id="my-points-label">
            My Points
          </div>
        </div>

        <div className={styles.divider}></div>

        <div
          className={styles.statItem}
          onClick={() => onClick?.("totalSaved", { points })}
        >
          <div className={styles.statValue} data-element-id="total-saved">
            $
            <OdometerCounter
              value={totalSaved || 0}
              format="(,ddd)"
              theme="default"
            />
          </div>
          <div className={styles.statLabel} data-element-id="total-saved-label">
            Total Saved
          </div>
        </div>
      </div>

      <div className={styles.bottomDecoration}></div>
    </div>
  );
};

export default MemberInfoCard;
